import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute() {
    const { admin, checking } = useAuth();
    const location = useLocation();

    if (checking) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-checking">
                <div className="text-acre-muted text-sm">Checking session…</div>
            </div>
        );
    }
    if (!admin) {
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }
    return <Outlet />;
}
